import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Provider } from 'unstated';

import { FloatingBannerStateContainer } from './FloatingBannerStateContainer';
import { BannerStateContainer } from './BannerStateContainer';

// useful for full-screen things like modals and preview page
export const WithoutBanners = React.memo(({ children }: React.PropsWithChildren<{}>) => (
	<Provider
		inject={[new BannerStateContainer({ hasTopNav: false }), new FloatingBannerStateContainer()]}
	>
		{children}
	</Provider>
));
